import http from "./httpService";

const apiEndpoint = "/api/billings";

function create(data) {
  return http.post(apiEndpoint, data);
}

function update(data) {
  return http.put(apiEndpoint, data);
}

function get(id) {
  return http.get(`${apiEndpoint}/${id}`);
}
function getAll() {
  return http.get(apiEndpoint);
}

function getAnalysisByPrograms() {
  return http.get(`${apiEndpoint}/analysis-by-program`);
}

function getAllList() {
  return http.get(apiEndpoint + "/list");
}

function deleteById(id) {
  return http.delete(`${apiEndpoint}/${id}`);
}

export default {
  create,
  update,
  get,
  getAll,
  getAnalysisByPrograms,
  getAllList,
  deleteById,
};
